export const COLOR_MODELS = {
    HSV: 'HSV',
    HSL: 'HSL',
    RGB: 'RGB',
    HEX: 'HEX'
};
